// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24fG2","type":"styles_type__2f-TB","choices":"styles_choices__3TsM2"};